export const MAX_NUMBER_OF_TIME_SERIES = 20;
